export default __webpack_public_path__ + "static/media/Logo_lg.5ad0c6de.png";